import React from "react";

function priorityColor(priority){

if(priority==="HIGH")
return "bg-red-100 text-red-700";

if(priority==="MEDIUM")
return "bg-amber-100 text-amber-700";

return "bg-green-100 text-green-700";

}

function normalize(item){

if(!item){

return{
text:"Undefined action",
priority:"MEDIUM",
effort:"MEDIUM",
impact:"MEDIUM"
};

}

if(typeof item==="string"){

return{

text:item,
priority:"MEDIUM",
effort:"MEDIUM",
impact:"MEDIUM"

};

}

return{

text:item.text || "Execution item",
priority:item.priority || "MEDIUM",
effort:item.effort || "MEDIUM",
impact:item.impact || "MEDIUM"

};

}

export default function AcquisitionTable({data}){

const channels = (data?.execution || [])
.filter(Boolean)
.map(normalize);

if(channels.length === 0){

return(

<div className="bg-white border rounded-xl p-6 shadow-sm">

<h3 className="text-xl font-semibold text-blue-900">
Acquisition Engine
</h3>

<p className="text-sm text-slate-500 mt-3">
No acquisition channels identified.
</p>

</div>

);

}

return(

<div className="bg-white border rounded-xl p-6 shadow-sm">

<h3 className="text-xl font-semibold text-blue-900 mb-2">
Acquisition Engine
</h3>

<p className="text-sm text-slate-600 mb-4">
AI recommended distribution channels to acquire early users.
</p>

<div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">

{channels.map((item,i)=>(

<div
key={i}
className="border border-slate-200 bg-slate-50 rounded-lg p-4 text-sm text-slate-700 hover:bg-slate-100 transition"
>

<div className="flex gap-3">

<div className="w-7 h-7 bg-blue-500 text-white rounded flex items-center justify-center text-xs font-semibold">

{i+1}

</div>

<div>

<p>
{item.text}
</p>

<div className="flex gap-2 mt-2 flex-wrap">

<span className={`text-xs px-2 py-1 rounded ${priorityColor(item.priority)}`}>
{item.priority}
</span>

<span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded">
Effort {item.effort}
</span>

<span className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded">
Impact {item.impact}
</span>

</div>

</div>

</div>

</div>

))}

</div>

</div>

);

}